var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"factoring-carrier-list"},[_c('h2',{staticClass:"title"},[_vm._v("\n    Carriers pending approval\n  ")]),_c('carrier-approvals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }